module.exports = __webpack_public_path__ + "assets/img/swiss_meringue_active.dcdeade5.png";